// extracted by mini-css-extract-plugin
export default {"analytics":"AnalyticsPage_analytics_Cp5UI","tableContent":"AnalyticsPage_tableContent_JSGYZ","container":"AnalyticsPage_container_NrsM9"};